import React, { useState } from 'react';

import { Alert, Box, Button, Grid, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import { TitlePages } from '@/components/Base/TitlePage';
import Thermometer from '@/components/Base/Thermometer';
import { useTermometroFinanceiroDetalhes } from '@/features/termometro/getTermometroFinanceiroDetalhes';
import KpiComponentGreen from '@/components/Base/KpiComponentGreen';
import { getConsolidationSummaryStudentsFrequency } from '@/features/dashboard/api/getConsolidationSummaryStudentsFrequency';
import { useTermometroFrequenciaAluno } from '@/features/termometro/getTermometroFrequenciaAluno';

const getPositionFromScore = (month_score) => {
  if (month_score >= 0 && month_score < 3.33) {
    return 'end';
  } else if (month_score >= 3.33 && month_score < 6.66) {
    return 'center';
  } else if (month_score >= 6.66 && month_score <= 10) {
    return 'start';
  } else {
    return 'end';
  }
};

export const TermometroFrequenciaAlunos = ({ routeBack }) => {
  const [open, setOpen] = useState(false);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);

  const location = useLocation();
  const { id, name } = location.state || {};

  const { data: summary, isError, refetch, isFetching, isFetched } = useTermometroFrequenciaAluno(id);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const onApplyFilter = (selectedYear: number) => {
    setOpen(!!selectedYear);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{ cursor: 'pointer' }} onClick={() => navigate(routeBack)} />
          <TitlePages title={'Termômetro frequência por aluno'} />
        </Stack>

        <Stack flexDirection={'row'} gap={'20px'}>
          <Button
            onClick={() => navigate('/inadimplencia-recomendacoes-alunos', { state: { id: id ? id : summary?.student_id, name } })}
            variant="contained"
            sx={{ fontWeight:'700', borderRadius: '24px', fontSize: '14px', height: '37px', color: '#fff', textTransform: 'capitalize', backgroundColor: '#15AB51'}}
          >
            Visualizar recomendação
          </Button>
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        {summary && isFetched && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              <KpiComponentGreen title={'Score geral'} 
                value={String(summary?.average_frequency_score).replace('.', ',')} 
                // value={"9,5"}
              />
              <KpiComponent title={'Situação'} 
                value={summary?.situation ? 'Ativo' : 'Inativo'} 
              />
              <KpiComponent title={'Score frequência'} 
                value={`${summary?.frequency_score}`} 
                // value={"7"}
              />
              <KpiComponent title={'Score financeiro'} 
                value={`${summary?.financial_score?.value}`} 
                // value={"8"}
              />
              <KpiComponent title={'Índice de Faltas'} 
                value={`${summary?.index_absence}`} 
                // value={"5%"}
              />
            </Stack>
          </Stack>
        )}
        {isFetching && !summary && <LoadingSummary />}
        <Box sx={{ maxWidth: '1250px' }}>
          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Thermometer 
              score={summary?.average_frequency_score || 0}
            />
          </Box>

          <Box sx={{ boxShadow: '0px 4px 4px 0px #00000040' }} m={'30px 0'} p={'20px'}>
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
              <Box fontSize={'16px'} fontWeight={400}>
                Aluna: <span style={{ fontWeight: 600 }}>{`${name ?? summary?.student_name} ${summary?.student_info?.serie ? `- ${summary?.student_info?.serie}` : ''}`}</span>
              </Box>

              {summary?.average_frequency_score <6 && <Box maxWidth={'477px'} fontStyle={'italic'} color={'#E04A4C'}>
                . Em decorrência do score do aluno abaixo da média, é necessário o registro de uma advertência.
              </Box>}
            </Stack>

            <Stack maxWidth={'470px'} mt={'40px'} flexDirection={'row'} justifyContent={'space-between'}>
              <Typography fontWeight={'600'} fontSize={'14px'} color={'#3F4254'}>
                Score geral máximo
              </Typography>

              <Typography fontWeight={'600'} fontSize={'14px'} color={'#000'}>
                {summary?.min_max_score
                  ? String(summary?.min_max_score?.max_score?.value).replace('.', ',')
                  : '-'}
              </Typography>
            </Stack>

            <Stack maxWidth={'470px'} mt={'40px'} flexDirection={'row'} justifyContent={'space-between'}>
              <Typography fontWeight={'600'} fontSize={'14px'} color={'#3F4254'}>
                Score geral mínimo
              </Typography>

              <Typography fontWeight={'600'} fontSize={'14px'} color={'#000'}>
                {summary?.min_max_score
                  ? String(summary?.min_max_score?.min_score?.value).replace('.', ',')
                  : '-'}
              </Typography>
            </Stack>
          </Box>
        </Box>
      </Box>
    </>
  );
};
